/* eslint-disable no-unused-expressions */
// /**
//  * app.js
//  *
//  * This is the entry file for the application, only setup and boilerplate
//  * code.
//  */

// // Needed for redux-saga es6 generator support
// import '@babel/polyfill';
// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
// import React from 'react';
// import ReactDOM from 'react-dom';
// import { ConnectedRouter } from 'connected-react-router';
// import { Provider } from 'react-redux';

// import history from './utils/history';
// import configureStore from './configureStore';

// import './styles/css/chargecard.css';
// import './styles/scss/styles.scss';
// import '@vatechsoftware/widgets/ProductStyles/index.scss';

// // Import root app
// import App from './components/App';

// // Create redux store with history
// const initialState = {};
// const store = configureStore(initialState, history);
// const MOUNT_NODE = document.getElementById('root');

// const render = () => {
//   ReactDOM.render(
//     <Provider store={store}>
//       <ConnectedRouter history={history}>
//         <App />
//       </ConnectedRouter>
//     </Provider>,
//     MOUNT_NODE,
//   );
// };

// if (module.hot) {
//   // Hot reloadable React components and translation json files
//   // modules.hot.accept does not accept dynamic dependencies,
//   // have to be constants at compile-time
//   module.hot.accept(['./components/App'], () => {
//     ReactDOM.unmountComponentAtNode(MOUNT_NODE);
//     render();
//   });
// }

// render();
import('./bootstrap');
